import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useUser } from "../UserContext";
import { useLocation } from "react-router-dom";

const CancelSubscriptionReviews = ({ isOpen, onClose, onSubmit, subscriptionToCancel, facilityId, setLoading, setCancelProcessModal }) => {
    const [questions, setQuestions] = useState([]);
    const [selectedQuestions, setSelectedQuestions] = useState([]);
    const [selectQuestionText, setSelectedQuestionText] = useState([])
    const [otherReason, setOtherReason] = useState("");
    const location = useLocation();

    const token = localStorage.getItem("token");
    const user = useUser();
    const ACCESS_TOKEN = process.env.REACT_APP_TICKET_ACCESS_TOKEN;
    const APP_URL = process.env.REACT_APP_FRONTEND_URL;
    const TICKET_URL = process.env.REACT_APP_API_BASE_URL;



    const fetchQuestions = async () => {
        try {
            setLoading(true)
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/get-questionare/`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                }
            );

            if (!response.ok) throw new Error();
            const data = await response.json();
            setQuestions(data);
            setLoading(false)
        } catch {
            toast.error("Failed to load questions");
            setLoading(false)
        }
    };

    useEffect(() => {
        fetchQuestions();

    }, []);

    const toggleQuestion = (review) => {
        setSelectedQuestions((prev) =>
            prev.includes(review?.id)
                ? prev.filter((q) => q !== review?.id)
                : [...prev, review?.id]
        );
        setSelectedQuestionText((prev) =>
            prev.includes(review?.id)
                ? prev.filter((q) => q !== review?.id)
                : [...prev, review?.title]
        );

    };

    const userDetails = user?.user?.user;
    const facilityDetail = user?.user?.facility;
    const ZAMMAD_BASE = "https://support.alfboss.com/api/v1";
    const AUTH_HEADERS = {
        "Authorization": `Bearer ${ACCESS_TOKEN}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
    };

    const TICKET_HEADERS = {
        "Content-Type": "application/json",
        "Accept": "application/json",
    };

    const [lastVisited, setLastVisited] = useState(() => localStorage.getItem("lastVisited") || "");

    useEffect(() => {
        localStorage.setItem("lastVisited", location.pathname);
        setLastVisited(location.pathname);
    }, [location]);

    const selectedReasonsHtml = selectQuestionText?.map((reason, index) => `${index + 1}. ${reason}`).join("<br/>");
    const handleSubmitQuery = async () => {
        setLoading(true)
        try {
            const oldUser = await fetch(
                `${ZAMMAD_BASE}/users/search?query=${userDetails?.email}`,
                { headers: AUTH_HEADERS }
            );

            const oldUserResponse = await oldUser.json();
            let customerId = null;

            if (Array.isArray(oldUserResponse) && oldUserResponse?.length > 0) {
                customerId = oldUserResponse[0]?.id; // existing user
            } else {
                const createUserPayload = {
                    firstname: userDetails?.first_name,
                    lastname: userDetails?.last_name,
                    email: userDetails?.email,
                    login: userDetails?.email,
                    role_ids: [3] // customer role in Zammad
                };
                const searchRes = await fetch(
                    `${ZAMMAD_BASE}/users`, {
                    method: "POST",
                    headers: AUTH_HEADERS,
                    body: JSON.stringify(createUserPayload),
                })

                const searchData = await searchRes.json();
                customerId = searchData?.id;
            }
            if (!customerId) {
                toast.error("Unable to find or create Zammad user.");
                setLoading(false)
                return;
            }
            const ticketPayload = {
                title: 'Subscription Cancellation',
                group_id: 1,          // Your Zammad group ID
                customer_id: customerId,
                state_id: 1,          // open
                priority_id: 2        // normal
            };

            const ticketRes = await fetch(`${ZAMMAD_BASE}/tickets`, {
                method: "POST",
                headers: AUTH_HEADERS,
                body: JSON.stringify(ticketPayload),
            });

            const ticket = await ticketRes.json();

            if (!ticket.id) {
                toast.error("Zammad: Ticket creation failed.");
                setLoading(false)
                return;
            }

            const articlePayload = {
                ticket_id: ticket.id,
                type: "email",
                sender: "Agent",                // REQUIRED
                from: "alfsupport@alfboss.com",              // REQUIRED (customer)
                to: userDetails?.email,      // REQUIRED (support email)
                subject: 'Subscription Cancellation',
                body: `
    User: ${userDetails?.first_name || userDetails?.username}<br/>
    Email: ${userDetails?.email}<br/>
    Facility: ${facilityDetail?.name} (ID ${facilityDetail?.id})<br/>
    Last Visited: ${APP_URL}${lastVisited || 'N/A'}<br/>

    <hr/>
     ${selectedReasonsHtml || ""}<br/>
   ${otherReason || ""}
  `,
                content_type: "text/html",
                internal: false
            };

            await fetch(`${ZAMMAD_BASE}/ticket_articles`, {
                method: "POST",
                headers: AUTH_HEADERS,
                body: JSON.stringify({
                    ticket_id: ticket.id,
                    ...articlePayload
                }),
            });

            const DBTICKETPAYLOD = {
                ticket_id: ticket?.id,
                user: userDetails?.id,
                subject: 'Subscription Cancellation',
                message: selectedReasonsHtml,
                status: "open",
                type: "Support",
                email: userDetails?.email
            };


            await fetch(`${TICKET_URL}/tickets/create/`, {
                method: "POST",
                headers: TICKET_HEADERS,
                body: JSON.stringify({
                    ...DBTICKETPAYLOD
                }),
            });

            setLoading(false)
            setCancelProcessModal(true)
        } catch (error) {
            setLoading(false)
            setCancelProcessModal(false)
        }
    }
    const handleSubmit = async () => {
        setLoading(true)
        const payload = {
            reason: selectedQuestions,
            additional_comments: otherReason,
            subscription: subscriptionToCancel,
            facility: facilityId,
        };
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_BASE_URL}/subscription-cancel-reason/`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            if (!response.ok) {
                setLoading(false);
                throw new Error();
            } else {
                // onSubmit();
                handleSubmitQuery()
                setLoading(false);
            }
        } catch {
            toast.error("Failed to load questions");
            setLoading(false);
        }
        onClose();
        setLoading(false);
    };



    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm">
            <div className="bg-white w-full max-w-4xl rounded-2xl shadow-xl">

                {/* Header */}
                <div className="p-6 border-b flex justify-between items-center">
                    <h2 className="text-4xl font-semibold text-gray-800 m-0">
                        Why are you cancelling?
                    </h2>
                </div>

                {/* Body */}
                <div className="p-6 max-h-[60vh] overflow-y-auto space-y-4">

                    {questions?.map((q) => (
                        <label
                            key={q?.id}
                            className="flex items-start gap-3 p-4 border rounded-xl cursor-pointer hover:bg-gray-50 transition"
                        >
                            <input
                                type="checkbox"
                                checked={selectedQuestions.includes(q?.id)}
                                onChange={() => toggleQuestion(q)}
                                className="mt-1 w-6 h-6 accent-emerald-600"
                            />
                            <span className="text-gray-700 font-medium">
                                {q?.title}
                            </span>
                        </label>
                    ))}

                    {/* Other reason */}
                    <div className="pt-4">
                        <label className="block font-medium text-gray-700 mb-2">
                            Other reason (optional)
                        </label>
                        <textarea
                            rows={3}
                            value={otherReason}
                            onChange={(e) => setOtherReason(e.target.value)}
                            placeholder="Tell us anything else..."
                            className="w-full border rounded-xl p-3 focus:ring-2 focus:ring-emerald-500 focus:outline-none"
                        />
                    </div>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-3 p-6 border-t">
                    <button
                        onClick={onClose}
                        className="px-4 py-3 rounded-lg border hover:bg-gray-100"
                    >
                        Keep Subscription
                    </button>
                    <button
                        disabled={otherReason ? false : selectedQuestions?.length === 0}
                        onClick={handleSubmit}
                        className="px-4 py-3 rounded-lg bg-red-600 text-white hover:bg-red-700 disabled:opacity-50"
                    >
                        Cancel Subscription
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelSubscriptionReviews;
